import React from 'react'
import DestinyTooltip from './components/DestinyTooltip';
import {Button, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText} from '@mui/material'
import './App.css';

function App() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="container">
      <br></br>
      <div>
      <Button variant="outlined" onClick={handleClickOpen}>
        README
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{zIndex: 999999999}}
      >
        <DialogTitle id="alert-dialog-title">
          {"This is a side-project/proof-of-concept"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <b>This is a desktop app first! This isn't designed for mobile.</b><br></br>The performance is absolutely not optimised, it rerenders everything any time you change something. Not great, but it doesn't really need to be performant. When changing the colour of items, try to just click towards the colour you want. Avoid dragging the eyedrop tool. The CSS behind the scenes is a bit of a mess, I'm not amazing with CSS and this is my first project using React. I made this in a few days, but it works, and that's all that matters!<br></br><br></br>The UI is not exactly friendly, but you didn't need me to tell you that. It's just designed to get the job done. Experiment!<hr></hr><h3>Stats + Mods</h3>Weapon/Armor stats and mods can go up to 10. A new option for adding one appears each time you give a new stat/mod a name.<hr></hr><h3>Hiding/Showing Elements</h3>Some parts of the tooltip can be turned off completely using a checkbox that controls that section. Some elements might show and hide themselves if you remove all values from it (like a weapon/armor stat bar), and some might appear when you give them a value (like a tooltip description or missing requirement warning message.<hr></hr><h3>DestinySymbols</h3>You can use any of the symbols from this site in this tool: <a target="newtab" href="https://nathanrsxtn.github.io/Destiny-2-Font-Symbols/">https://nathanrsxtn.github.io/Destiny-2-Font-Symbols/</a> (Opens in new tab)<hr></hr><h3>Missing customization?</h3>Don't forget, you're in a browser! Inspect element is your friend!
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Got it
          </Button>
        </DialogActions>
      </Dialog>
      </div>
      <DestinyTooltip
        masterwork={true}
        header_background_color="#c0a339"
        box_background_color="#272417"
        header_title_text="Izanagi's Burden"
        header_title_text_color="#ffffff"
        header_subtitle_text="Sniper Rifle"
        header_subtitle_text_color="#e5d9af"
        header_subtitle_rarity_text="Exotic"
        header_subtitle_rarity_text_color="#e3d14d"
        header_missingRequirementWarning_text=''
        item_bool={true}
        item_power_text='1566'
        item_power_text_color='#ffffff'
        item_energydamagetype='none'
        item_weaponTypeBool={true}
        item_weaponammotype='special'
        item_ammotype_text='Special'
        item_ammotype_text_color='#ffffff'
        item_armorbool={false}
        item_armorAffinitytype='stasis'
        item_armorAffinity_text='Energy'
        item_armorAffinity_text_color='#d7d6d2'
        item_armorAffinity_number_text='10'
        item_armorAffinity_number_color='#4e87ff'
        item_craftedBool={false}
        item_craftedWeaponProgressBarText='Weapon Lv. 107'
        item_craftedWeaponProgressBarPercentageText='68%'
        item_craftedWeaponProgressBarPercentageValue={68}
        item_killTracker_bool={true}
        item_killTrackerIconLink='https://www.bungie.net/common/destiny2_content/icons/1c0c674ed40bec52e8e0691f9020beea.png'
        item_killTrackerName_text='Enemies Defeated'
        item_killTrackerName_text_color='#c6c5c7'
        item_killTrackerValue_text='1,624'
        item_killTrackerValue_text_color='#ba974b'
        item_statBox_bool={true}
        item_statBox_stat1_name_text='Impact'
        item_statBox_stat1_barBase_value={70}
        item_statBox_stat1_barMasterwork_value={0}
        item_statBox_stat1_value_text='70'
        item_statBox_stat1_value_masterwork={false}

        item_statBox_stat2_name_text='Range'
        item_statBox_stat2_barBase_value={58}
        item_statBox_stat2_barMasterwork_value={0}
        item_statBox_stat2_value_text='58'
        item_statBox_stat2_value_masterwork={false}

        item_statBox_stat3_name_text='Stability'
        item_statBox_stat3_barBase_value={56}
        item_statBox_stat3_barMasterwork_value={0}
        item_statBox_stat3_value_text='56'
        item_statBox_stat3_value_masterwork={false}

        item_statBox_stat4_name_text='Handling'
        item_statBox_stat4_barBase_value={47}
        item_statBox_stat4_barMasterwork_value={0}
        item_statBox_stat4_value_text='47'
        item_statBox_stat4_value_masterwork={false}

        item_statBox_stat5_name_text='Reload Speed'
        item_statBox_stat5_barBase_value={40}
        item_statBox_stat5_barMasterwork_value={0}
        item_statBox_stat5_value_text='40'
        item_statBox_stat5_value_masterwork={false}

        item_statBox_stat6_name_text='Rounds Per Minute'
        item_statBox_stat6_barBase_value={0}
        item_statBox_stat6_barMasterwork_value={0}
        item_statBox_stat6_value_text='90'
        item_statBox_stat6_value_masterwork={false}

        item_statBox_stat7_name_text='Magazine'
        item_statBox_stat7_barBase_value={0}
        item_statBox_stat7_barMasterwork_value={0}
        item_statBox_stat7_value_text='4'
        item_statBox_stat7_value_masterwork={false}

        item_statBox_stat8_name_text=''
        item_statBox_stat8_barBase_value={0}
        item_statBox_stat8_barMasterwork_value={0}
        item_statBox_stat8_value_text=''
        item_statBox_stat8_value_masterwork={false}

        item_statBox_stat9_name_text=''
        item_statBox_stat9_barBase_value={0}
        item_statBox_stat9_barMasterwork_value={0}
        item_statBox_stat9_value_text=''
        item_statBox_stat9_value_masterwork={false}

        item_statBox_stat10_name_text=''
        item_statBox_stat10_barBase_value={0}
        item_statBox_stat10_barMasterwork_value={0}
        item_statBox_stat10_value_text=''
        item_statBox_stat10_value_masterwork={false}

        item_modBox_bool={true}

        item_modBox_mod1_iconLink='https://www.bungie.net/common/destiny2_content/icons/ab986167a03f6f9eb1d22835fb2bec63.png'
        item_modBox_mod1_name_text='Honed Edge'
        item_modBox_mod1_description_text=' Press : Consume the magazine and load a more powerful round.'
        item_modBox_mod1_type='exotic'

        item_modBox_mod2_iconLink='https://www.bungie.net/common/destiny2_content/icons/a5adc38b39f910897be1548c7dd0c270.png'
        item_modBox_mod2_name_text='No Distractions'
        item_modBox_mod2_description_text=''
        item_modBox_mod2_type='normal'

        item_modBox_mod3_iconLink='https://www.bungie.net/common/destiny2_content/icons/a885b58633525f32b885e954c9083698.png'
        item_modBox_mod3_name_text='Peerless Edge'
        item_modBox_mod3_description_text=''
        item_modBox_mod3_type='normal'

        item_modBox_mod4_iconLink=''
        item_modBox_mod4_name_text=''
        item_modBox_mod4_description_text=''
        item_modBox_mod4_type='normal'

        item_modBox_mod5_iconLink=''
        item_modBox_mod5_name_text=''
        item_modBox_mod5_description_text=''
        item_modBox_mod5_type='normal'

        item_modBox_mod6_iconLink=''
        item_modBox_mod6_name_text=''
        item_modBox_mod6_description_text=''
        item_modBox_mod6_type='normal'

        item_modBox_mod7_iconLink=''
        item_modBox_mod7_name_text=''
        item_modBox_mod7_description_text=''
        item_modBox_mod7_type='normal'

        item_modBox_mod8_iconLink=''
        item_modBox_mod8_name_text=''
        item_modBox_mod8_description_text=''
        item_modBox_mod8_type='normal'

        item_modBox_mod9_iconLink=''
        item_modBox_mod9_name_text=''
        item_modBox_mod9_description_text=''
        item_modBox_mod9_type='normal'

        item_modBox_mod10_iconLink=''
        item_modBox_mod10_name_text=''
        item_modBox_mod10_description_text=''
        item_modBox_mod10_type='normal'

        footer_text=' Details     Dismantle'
        footer_textColor='#ffffff'
        footer_backgroundColor='#000000'
      />
    </div>
  );
}

export default App;
